if (!customElements.get('logo-vertical-slide')) {
  class LogoVerticalSlide extends HTMLElement {
    connectedCallback() {
      this.duration = parseInt(this.dataset.duration, 10) || 800;
      this.stagger = parseInt(this.dataset.stagger, 10) || 50;
      this.pause = parseInt(this.dataset.pause, 10) || 400;
      this.tracks = Array.from(this.querySelectorAll('.lvs-track'));
      this._destroyed = false;
      this._visible = false;
      this._running = false;

      if (!this.tracks.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const counts = this.tracks.map((t) => t.children.length);
      const max = Math.max.apply(null, counts);
      if (max < 2) return;
      this.steps = max;

      // Pad every track to the same length, then append a copy of the first
      // logo so the snap back to 0 is invisible (seamless loop).
      this.tracks.forEach((track) => {
        const originals = Array.from(track.children);
        let i = 0;
        while (track.children.length < this.steps + 1) {
          const clone = originals[i % originals.length].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          i++;
        }
      });

      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this._visible = entry.isIntersecting;
            if (entry.isIntersecting) this._start();
          });
        },
        { threshold: 0.2 }
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      this._destroyed = true;
      if (this._io) this._io.disconnect();
    }

    _wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    _slide(track, percent) {
      return new Promise((resolve) => {
        let settled = false;
        const done = () => {
          if (settled) return;
          settled = true;
          track.removeEventListener('transitionend', done);
          clearTimeout(fallback);
          resolve();
        };
        const fallback = setTimeout(done, this.duration + 120);
        track.addEventListener('transitionend', done);
        track.style.transition = 'transform ' + this.duration + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
        track.style.transform = 'translate3d(0, ' + percent + '%, 0)';
      });
    }

    async _start() {
      if (this._running) return;
      this._running = true;
      while (!this._destroyed) {
        for (let step = 1; step <= this.steps; step++) {
          await this._wait(this.pause);
          for (let i = 0; i < this.tracks.length; i++) {
            if (this._destroyed) return;
            if (i > 0) await this._wait(this.stagger);
            await this._slide(this.tracks[i], step * -100);
          }
        }
        // Instant reset — the duplicated first logo is showing, so jumping
        // back to 0 produces no visible change.
        this.tracks.forEach((track) => {
          track.style.transition = 'none';
          track.style.transform = 'translate3d(0, 0, 0)';
          track.getBoundingClientRect();
        });
        while (!this._visible && !this._destroyed) {
          await this._wait(300);
        }
      }
    }
  }
  customElements.define('logo-vertical-slide', LogoVerticalSlide);
}